import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import * as compose from 'lodash.flowright';
import { Mutation } from 'react-apollo';
import CradInterview from '../card-interview/card-interview.component';
//styles and icons 
import { Paper, Button, TextField, InputLabel, Typography, FormControl, Select } from '@material-ui/core';
import { Row, Col, Modal } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import workIcon from '../../../images/work.svg';
import Skeleton from '@material-ui/lab/Skeleton';

// this component represent the profile part in explore opportunities page 

class jobPosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCountryId: ''
        }
    }
    componentWillMount() {
    }
    render() {
            return (
                <div className="saved-posts">
                    {/* <Paper className="p-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                        <Row >
                            <Col md={12}>
                                <Row className="m-0 mb-3 align-items-center">
                                    <Col className="text-left p-0">
                                        <h6 className="bold mb-0">
                                            Job posts 
                                        </h6>
                                        <p className="pt-2">All your saved and applied posts in one place</p>
                                    </Col>
                                </Row>
                                <Row className="m-0 mb-3">
                                    <Col className="p-0">
                                        <Button size="small" style={{fontSize : '0.8rem'}} className="bg-dark text-white mr-2 pr-2 pl-2"  varient="contained">Saved Job posts</Button>
                                        <Button size="small" style={{fontSize : '0.8rem'}}  className="bg-grey text-dark pr-2 pl-2"   varient="contained">Applied Job posts</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Paper> */}
                    <Paper className="p-3 mt-4" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                        <Row >
                            <Col md={12}>
                                <Row className="m-0 mb-3 align-items-center">
                                    <Col className="text-left p-0">
                                        <h6 className="bold mb-0">
                                              <span ><img src={workIcon} alt="icon"  className="pr-3 pb-1"/></span>
                                              Saved Job posts
                                        </h6>
                                    </Col>
                                    <Col className="text-right">
                                        <p style={{fontSize : '14px'}} className="mb-0"> Sort by: <span className="text-orange">Latest</span></p>
                                    </Col>
                                </Row>
                                <Row className="m-0 mb-3">
                                    <Col  md='12' className="p-0" style={{borderBottom:'1px solid #f2f2f2'}}>
                                        <CradInterview />
                                    </Col>
                                    <Col md='12' className="p-0" style={{borderBottom:'1px solid #f2f2f2'}}>
                                        <CradInterview />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Paper>
                </div>);
        }
    }



export default withRouter(jobPosts)